<main>
  <app-tabs (tabChange)="onTabChange()">
    <app-tab [tabTitle]="scope + '.importCompanyToFirmSupport' | transloco">
      <div style="overflow: auto; height: 350px">
        <ng-container *ngIf="!loadingData; else loadingTpl">
          <app-import-missing-companies-to-byst
            [includeHidden]="includeHidden"
            (updated)="showWorkingSpinner = false; updated = true"
            (updating)="showWorkingSpinner = true"></app-import-missing-companies-to-byst>
        </ng-container>
      </div>
      <ng-container *appHideIfCountries="'NL'">
        <p-checkbox
          *ngIf="!loadingData && hasAccessToShowHiddenDatabases | async"
          class="mt-5 mb-0"
          [binary]="true"
          [(ngModel)]="includeHidden"
          [label]="scope + '.showAlsoHiddenDatabases' | transloco"></p-checkbox>
      </ng-container>
    </app-tab>
    <app-tab [tabTitle]="scope + '.exportCompanyToCloud' | transloco" *appHideIfCountries="'NL'">
      <div style="overflow: auto; height: 350px">
        <ng-container *ngIf="!loadingData; else loadingTpl">
          <app-export-companies-to-cloud (updated)="updated = true"></app-export-companies-to-cloud>
        </ng-container>
      </div>
    </app-tab>
    <app-tab [tabTitle]="scope + '.connectExistsingCompanies' | transloco">
      <div style="overflow: auto; height: 350px">
        <ng-container *ngIf="!loadingData; else loadingTpl">
          <app-sync-companies-between-byst-cloud
            (updating)="showWorkingSpinner = true"
            (updated)="showWorkingSpinner = false; updated = true"></app-sync-companies-between-byst-cloud>
        </ng-container>
      </div>
    </app-tab>
  </app-tabs>

  <div>
    <div class="inline align-bottom mr-2" *ngIf="showWorkingSpinner">
      <p-progressSpinner [style]="{ width: '23px', height: '23px' }" strokeWidth="6"></p-progressSpinner>
    </div>

    <div class="flex justify-end mt-6">
      <bl-frontend-button
        class="mr-2"
        [text]="'shared.close' | transloco"
        variant="secondary"
        (onclick)="close({ updated })"></bl-frontend-button>
      <bl-frontend-button
        [text]="'shared.add' | transloco"
        variant="primary"
        *ngIf="!hideAddButton"
        [disabled]="loadingData || showWorkingSpinner"
        (onclick)="onAddButton()"></bl-frontend-button>
    </div>
  </div>
</main>

<ng-template #loadingTpl>
  <div class="text-center mt-16">
    <img src="assets/ajax-loader.gif" [alt]="scope + '.workingPleaseWait' | transloco" class="mb-4 inline" /><br />
    {{ scope + '.collectingDatabaseInformation' | transloco }} <br />
    {{ scope + '.itCanTakeAFewMinutes' | transloco }}
  </div>
</ng-template>
